<template>
  <div
    v-if="loading < 2"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingClients"
  >
    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="searchFilter"
      >
        <span class="a-input-wrapper-row">
          <label for="url_academia">
            <input
              v-model="filter.url_academia"
              type="text"
              id="url_academia"
              name="url_academia"
              class="a-input-primary"
              placeholder="Academia"
              v-on:keyup.enter="readClientes"
            >
          </label>
        </span>
        <AtomSelectPrimary
          v-model.number="periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchFilter"
        />
        <span class="a-input-wrapper-row">
          <label for="pais">
            <select
              v-model="filter.pais"
              id="pais"
              name="pais"
              class="a-input-primary"
              @change="searchFilter"
            >
              <option value="0" disabled selected>País</option>
              <option
                v-for="pais in paises"
                :key="pais.id_pais"
                :value="pais.id_pais"
              >
                {{ pais.nombre }}
              </option>
            </select>
          </label>
        </span>
        <span class="a-input-wrapper-row">
          <label for="email">
            <input
              v-model="filter.email"
              type="text"
              id="email"
              name="email"
              class="a-input-primary"
              placeholder="Email cliente"
              v-on:keyup.enter="readClientes"
            >
          </label>
        </span>
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>
      <div class="display-flex-row margin-left-auto">
        <form
          autocomplete="off"
          class="m-form-row"
          name="download-csv-form"
          @submit.prevent="readClientesExportar"
        >
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="pagination.showLoadingState || !clientes.length"
          />
        </form>
      </div>
    </div>
    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="clientes.length">
          <th
            class="text-align-left"
            width="20%"
          >
            {{ $t('mEditionBillingAcademyClients.table.client') }}
          </th>
          <th class="text-align-right">
            {{ $t('mEditionBillingAcademyClients.table.eur') }}
          </th>
          <th class="text-align-right">
            {{ $t('mEditionBillingAcademyClients.table.usd') }}
          </th>
          <th class="text-align-right">
            {{ $t('mEditionBillingAcademyClients.table.ars') }}
          </th>
          <th class="text-align-right">
            {{ $t('mEditionBillingAcademyClients.table.mxn') }}
          </th>
          <th class="text-align-center" width="15%">
            {{ $t('mEditionBillingAcademyClients.table.lastSale') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingAcademyClients.table.products') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionBillingAcademyClients.table.view') }}
          </th>
        </tr>
        <tr
          v-for="(cliente, index) in clientes"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-block">
              {{ cliente.razon_social }}
            </span>
            <span class="font-size-small font-weight-light display-block">
              {{ cliente.email }}
            </span>
          </td>
          <td class="text-align-right"> {{ getMonto(cliente, 'EUR') }} </td>
          <td class="text-align-right"> {{ getMonto(cliente, 'USD') }} </td>
          <td class="text-align-right"> {{ getMonto(cliente, 'ARS') }} </td>
          <td class="text-align-right"> {{ getMonto(cliente, 'MXN') }} </td>
          <td
            class="text-align-center"
            width="15%"
          >
            {{ $moment.parseZone(cliente.ultimo_pago).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center"> {{ cliente.cant_productos }}</td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded"
              :element="cliente.id"
              @goToClientSales="goToClientSales(cliente)"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademyClients',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingAcademyClients.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingAcademyClients.tooltip.restart'),
          type: 'button'
        }
      },

      buttonIconRounded: {
        class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center',
        component: '',
        icon: 'far fa-file-alt',
        method: 'goToClientSales',
        tooltip: 'Acceder',
        type: 'button'
      },

      clientes: [],

      filter: {
        url_academia: '',
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pais: 0,
        pagina: 1
      },

      paises: [],

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      periodo: 0,
      loading: 0
    }
  },

  created () {
    // Verificar si viene una variable por GET, si no usar la configuración por defecto
    this.filter.url_academia = this.$route.query.academia_url || configApp.academyUrl
    this.readParametroPaises()
    this.readClientes()
  },

  methods: {
    getMonto (cliente, divisa) {
      const pago = cliente.pagos_totales.find((pago) => pago.iso_code === divisa)
      return pago ? `${pago.simbolo} ${pago.monto_total}` : '-'
    },

    goToClientSales (cliente) {
      const dataToSend = {
        academia: this.filter.url_academia,
        cliente: cliente
      }
      localStorage.setItem('dataKey', JSON.stringify(dataToSend))
      window.open(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.academyClients.subject')}/${cliente.id}/${this.$t('mEditionMenu.billing.academyClients.children.sales.subedition')}`, '_blank')
    },

    readClientes () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('cliente', 'getClientesPorAcademia', {}, [], this.filter)
          .then(response => {
            this.clientes = response.data.clientes
            this.pagination.currentQuantity = this.clientes.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.loading++
          })
          .catch(error => {
            console.log(error)
            this.loading++
            this.clientes = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademyClients', 'readClientes', 'error', 'a-alert-danger')
          })
      }
    },

    readClientesExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('cliente', 'exportClientesPorAcademia', {}, [], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingAcademyClients.files.clients')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyClients', 'readClientsExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyClients', 'readClientsExportar', 'error', 'a-alert-danger')
          })
      }
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.loading++
        })
        .catch(error => {
          console.log(error)
          this.loading++
        })
    },

    reloadListing () {
      this.resetFilter()
      this.setPaginationCurrentPage(1)
    },

    resetFilter () {
      this.filter = {
        url_academia: configApp.academyUrl,
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pais: 0,
        pagina: 1
      }
    },

    searchFilter () {
      if (this.filter.url_academia === '') {
        this.filter.url_academia = configApp.academyUrl
      }

      if (this.filter.periodo === '') {
        this.periodo = 0
      }

      this.filter.fecha_desde = this.$filters.parameters.periods[this.periodo].dateFrom
      this.filter.fecha_hasta = this.$filters.parameters.periods[this.periodo].dateTo
      this.readClientes()
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readClientes()
    }
  }
}
</script>
